// @ts-nocheck
const MessengerSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default MessengerSkeleton